// components/tabs/AmendmentsTab.jsx
import { EmptyState, Icons } from '../UI';
import { fmtDate, fmtMoney } from '../../utils/constants';

export default function AmendmentsTab({ contract, addAmendment }) {
  const amendments = contract.amendments || [];
  const s215 = contract.s215 || {};
  const originalMax = parseFloat(s215.maxAmount || contract.budget) || 0;

  return (
    <div>
      <div className="card">
        <div className="card-title-row">
          <h3 className="card-title" style={{ marginBottom: 0 }}>Amendments</h3>
          <button className="btn btn-gold btn-sm" onClick={addAmendment}>
            <Icons.plus /> Add Amendment
          </button>
        </div>

        {amendments.length === 0 ? (
          <EmptyState icon="⊕" title="No amendments yet"
            subtitle="Amendments are used to modify contract scope, timeline, or budget after execution."
            action={<button className="btn btn-gold" onClick={addAmendment}><Icons.plus /> Add Amendment</button>} />
        ) : (
          <>
            {/* Amendment history table */}
            <div style={{ marginBottom: 20, overflowX: 'auto' }}>
              <table className="data-table">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Agreement No.</th>
                    <th>Description</th>
                    <th>Date</th>
                    <th>Amount Change</th>
                    <th>New Max</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ fontFamily: 'var(--font-mono)', fontSize: 12 }}>Original</td>
                    <td style={{ fontFamily: 'var(--font-mono)', fontSize: 12 }}>{s215.agreementNum || '—'}</td>
                    <td>{contract.title}</td>
                    <td style={{ fontFamily: 'var(--font-mono)', fontSize: 12 }}>{fmtDate(contract.createdAt)}</td>
                    <td>—</td>
                    <td style={{ fontWeight: 600 }}>{fmtMoney(originalMax)}</td>
                  </tr>
                  {amendments.map(am => {
                    const chg = parseFloat(am.amountChange) || 0;
                    return (
                      <tr key={am.id}>
                        <td style={{ fontFamily: 'var(--font-mono)', fontSize: 12 }}>Am. {am.number}</td>
                        <td style={{ fontFamily: 'var(--font-mono)', fontSize: 12 }}>{am.agreementNum || '—'}</td>
                        <td>{am.description}</td>
                        <td style={{ fontFamily: 'var(--font-mono)', fontSize: 12 }}>{fmtDate(am.date)}</td>
                        <td style={{ color: chg > 0 ? 'var(--green-600)' : chg < 0 ? 'var(--red-600)' : 'inherit', fontWeight: 600 }}>
                          {chg !== 0 ? (chg > 0 ? '+' : '') + fmtMoney(chg) : '—'}
                        </td>
                        <td style={{ fontWeight: 600 }}>{fmtMoney(am.newMaxAmount)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Amendment details */}
            {amendments.map(am => (
              <div key={am.id} style={{ padding: 14, border: '1px solid var(--slate-200)', borderRadius: 'var(--r-md)', marginBottom: 10, background: 'var(--slate-50)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                  <div style={{ fontWeight: 700, fontSize: 13 }}>Amendment {am.number}</div>
                  <span style={{ fontSize: 11, color: 'var(--slate-400)', fontFamily: 'var(--font-mono)' }}>{fmtDate(am.date)}</span>
                </div>
                <div style={{ fontSize: 13, marginBottom: 6 }}>{am.description}</div>
                {am.reason && <div style={{ fontSize: 12, color: 'var(--slate-500)', fontStyle: 'italic' }}>{am.reason}</div>}
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
